import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import Loader from "../../../utils/Loader";
import { fill_action } from "../../../actions/common_action/fillList_action";
import {
    getCircularCompany_action,
    getCircularList_action,
    insertCicular_action,
    delCircular_action,
    assignCircular_action
} from "../../../actions/adminModule_action/circular_action";

import {
    paymentTypeActionId,
    toastSuccess,
    toastError,
} from "../../../utils/constants";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment-timezone";
import Header from "../../../common_components/Header";
import { emailValidator, mobileNoValidator } from "../../../utils/Validator";
import { forgetPassword_action } from "../../../actions/user_login_auth_actions/user_login_auth_action";
import Pagination from "../../../utils/pagination";
import DatePicker from "react-datepicker";
import Resizer from "react-image-file-resizer";
import { Modal } from "react-bootstrap";
import Footer from "../../../common_components/Footer";
import { Height } from "@mui/icons-material";
import MobileHeader from "../../../common_components/mobileHeader";

class AdminCircular extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            companyList: [],
            currentPage: 1,
            circularList: [],
            circularDate: "",
            circularTitle: "",
            circularFile: "",
            circularFileType: "",
            checkedAll: false,
            selectedCompany: [],
            isDelOpen: false,
            circular_id: "",
            companyName: "",
            paymentTypeId: "",
            exhibitorTypeId: "",
            paymentTypeList: [],
            exhibitorTypeList: [],
            loginAccesslist: [],

            // Err Messages
            circularDateErr: "",
            circularTitleErr: "",
            circularFileErr: "",
            circularFileName: "",
            ApplicationNo: '',
            isSendMail: false,
            userTypeId: 'All',
            Description: '',
            DescriptionErr: '',
        }
        this.updateItem = this.updateItem.bind(this)
    }

    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
            setTimeout(() => {
                this.props.navigate("/login");
            }, 500);
        }

        setTimeout(() => {
            {
                sessionStorage.getItem("role_id") == 2 ? (
                    this.props.navigate("/profile")
                ) : (
                    <></>
                );
            }
        }, 10);
        // this.getFillList(paymentTypeActionId, '', '', '', '', '');
        // this.getFillList(exhibitorTypeActionId, '', '', '', '', '');
        this.getCircularCompany()
        this.getCircularList()

    }

    getCircularCompany() {
        const { ApplicationNo, paymentTypeId, companyName, userTypeId } = this.state
        this.setState({ isLoading: true })
        this.props.getCircularCompany_action(ApplicationNo, paymentTypeId, companyName, userTypeId)
            .then((data) => {
                if (data.error != 1) {
                    data.data.length > 0 && data.data.map((item) => {
                        item.Is_Select = false
                    })
                    this.setState({
                        companyList: data.data,
                        isLoading: false
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    // Update Current Page
    updateItem(item) {
        const { companyList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = companyList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(companyList.length / recordsPerPage)
    }

    // Get Circular List
    getCircularList() {
        this.setState({ isLoading: true })
        this.props.getCircularList_action()
            .then((data) => {
                if (data.error != 1) {
                    data.data.length > 0 && data.data.map((item) => {
                        item.isSelect = false
                    })
                    this.setState({
                        circularList: data.data,
                        isLoading: false
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    // Insert Circular 
    insertCircular(e) {
        const { circularDate, circularFile, circularTitle, circularDateErr, circularFileErr, isSendMail, circularTitleErr, companyList, circularFileType, Description, DescriptionErr } = this.state
        this.inputValidate()
        // var selectedCompany = companyList.length > 0 && companyList.filter((item) => item.Is_Select == true)
        if (circularDate != "" && circularTitle != "" && circularFile != "" && Description != '') {
            if (circularDateErr == "" && circularTitleErr == "" && circularFileErr == "" && DescriptionErr == '') {
                var selectedCompany = []
                selectedCompany = companyList.length > 0 && companyList.filter((item) => item.Is_Select == true)
                if (selectedCompany.length > 0) {
                    // circular data Preparing to store
                    var list = []
                    selectedCompany.length > 0 && selectedCompany.map(data => {
                        var mapData = {
                            'user_id': parseInt(data.user_id),
                        }
                        list.push(mapData)
                    });
                    this.setState({ isLoading: true })
                    this.props.insertCicular_action(circularDate, circularTitle, circularFile, list, circularFileType, isSendMail, Description)
                        .then((data) => {
                            if (data.error != 1) {
                                this.setState({
                                    isLoading: false,
                                })
                                toastSuccess("Circular Added Successfully")
                                // this.props.navigate('/addcircular')
                                this.handleClear()
                            } else {
                                this.setState({ isLoading: false })
                                toastError(data.msg)
                            }
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                } else {
                    toastError("Please Select Atleast One Applicant or Jury")
                }
            } else {
                toastError("Please Fill Mandatory Input Fields")
            }
        } else {
            toastError("Please Fill Mandatory Input Fields")
        }



    }

    // Input Feilds Validation
    inputValidate() {
        const { circularDate, circularTitle, circularFile, Description } = this.state

        if (circularDate == "") {
            this.setState({ circularDateErr: 'Please Select Circular Date' })
        }
        if (circularTitle == "") {
            this.setState({ circularTitleErr: 'Please Enter Circular Title' })
        }
        if (circularFile == "") {
            this.setState({ circularFileErr: 'Please Select Circular File' })
        }
        if (Description == "") {
            this.setState({ DescriptionErr: 'Please Enter Circular Description' })
        }
    }

    // On Cicular File Select
    onFilePick = async (e, file) => {
        e.preventDefault()
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf')

                ) {
                    if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelect(file[0]);
                        this.setState({ circularFile: image, circularFileErr: '', circularFileName: file[0]['name'] })
                    }
                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")

                    }
                    this.setState({ circularFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                } else {
                    toastError('Only .pdf files are allowed')
                }
            }
        }
    }

    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            let fileReader = new FileReader();
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                resolve(base64);
            };
            fileReader.readAsDataURL(file);
        });

    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });

    //on Select All Click
    selectAllCompany(e) {
        const { checkedAll, companyList } = this.state
        this.setState({ checkedAll: !checkedAll })
        const checked = e.target.checked
        companyList.length > 0 && companyList.map((data) => {
            if (checked) {
                data.Is_Select = true
            } else {
                data.Is_Select = false
            }
        })
        this.setState({ selectedCompany: companyList })
    }

    // On Checked Company
    handleCheckedCompany(e, id) {
        const { companyList, selectedCompany } = this.state
        const checked = e.target.checked

        companyList.length > 0 && companyList.map((data) => {
            if (data.user_id == id) {
                if (checked) {
                    data.Is_Select = true
                } else {
                    data.Is_Select = false
                    this.setState({ checkedAll: false })
                }
            }
        })
        this.setState({})
    }

    // On Delete Circular
    delCircular(id) {
        const confirmed = window.confirm(
            "Do you really want to delete this record ?"
        );

        if (confirmed) {
            this.setState({ isLoading: true })
            this.props.delCircular_action(id)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({
                            isDelOpen: false,
                            isLoading: false
                        })
                        toastSuccess("Circular Deleted Successfully")
                        this.handleClear()
                    } else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }

    handleClear() {
        this.setState({
            circularDate: '',
            circularTitle: '',
            circularFile: '',
            list: [],
            circularFileType: '',
            isSendMail: false,
            circularFileName: ''
        }, () => {
            this.getCircularList()
        })
    }

    handleFilterClear() {
        this.setState({
            ApplicationNo: '',
            companyName: '',
            userTypeId: 'All',
            paymentTypeId: '',
        }, () => {
            this.getCircularCompany()
        })
    }

    //toggle for delete
    toggleDelModal(id) {
        const { isDelOpen } = this.state
        this.setState({
            isDelOpen: !isDelOpen, circular_id: id
        })
    }

    // Get Fill Lists
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // Payment Type list
                    if (actionID === paymentTypeActionId) {
                        this.setState({
                            paymentTypeList: data.data.length > 0 ? data.data : [],
                            isLoading: false
                        })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    // On Search Click
    onSearchClick() {
        this.getCircularCompany()
    }

    getWirteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '14');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    getDeleteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '14');
        if (moduleAccess) {
            return moduleAccess.DeleteAccess;
        } else {
            return false
        }
        return false;
    }

    checkedCirculars(e, id) {
        const { circularList } = this.state
        const checked = e.target.checked

        circularList.length > 0 && circularList.map((data) => {
            if (data.circular_id == id) {
                if (checked) {
                    data.isSelect = true
                } else {
                    data.isSelect = false
                }
            }
        })
        this.setState({})
    }

    assignCircular() {
        const { circularList, companyList } = this.state
        var selectedCompany = []
        selectedCompany = companyList.length > 0 && companyList.filter((item) => item.Is_Select == true)
        var selectedCircular = []
        selectedCircular = circularList.length > 0 && circularList.filter((item) => item.isSelect == true)

        if (selectedCircular.length > 0) {
            if (selectedCompany.length > 0) {
                // circular User data Preparing to store
                var list = []
                selectedCompany.map(data => {
                    selectedCircular.map(item => {
                        var mapData = {
                            'user_id': parseInt(data.user_id),
                            'circular_id': parseInt(item.circular_id),
                        }
                        list.push(mapData)
                    });
                });

                // circular data Preparing to store
                // var list2 = []
                // selectedCircular.map(data => {
                //     var mapData = {
                //         'circular_id': parseInt(data.circular_id),
                //     }
                //     list2.push(mapData)
                // });
                this.setState({ isLoading: true })
                this.props.assignCircular_action(list, this.state.isSendMail)
                    .then((data) => {
                        if (data.error != 1) {
                            this.setState({ isLoading: false })
                            toastSuccess("Circular Assign Successfully")
                        } else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else {
                toastError("Please Select Atleast One Applicant or Jury")
            }
        } else {
            toastError("Please Select Atleast One Circular")
        }
    }

    removeFile() {
        this.setState({
            circularFile: '',
            circularFileName: '',
        })
    }

    render() {
        const { isLoading, companyList, currentPage, circularDate, circularTitle, circularDateErr, circularTitleErr, circularFileErr, Description, DescriptionErr,
            checkedAll, circularList, isDelOpen, companyName, paymentTypeId, exhibitorTypeId, paymentTypeList, circularFileName, ApplicationNo, userTypeId } = this.state;

        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };

        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = companyList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(companyList.length / recordsPerPage)


        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    <>
                        <main id="main">
                            
                                        <div className="website-view">
                                          <Header data={[8]} />
                                        </div>
                                        <div className="mobile-view">
                                          <MobileHeader data={[8]} />
                                        </div>
                            <section class='header_margin_top'>
                                <div class="container-fluid">
                                    <div class="page-header">
                                        <h2 className="mb-3 dashboard-tit  py-0 blog-name blog-name-1">Circular</h2>
                                    </div>
                                    <div class="">
                                        <div class="card-body">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-xl-4">
                                                            <label htmlFor="validationCustom03">Circular Date<span style={{ color: 'red' }}>*</span></label>
                                                            <DatePicker
                                                                selected={circularDate}
                                                                dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                onChange={(date) => this.setState({ circularDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), circularDateErr: "" })}
                                                                peekNextMonth
                                                                minDate={new Date()}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                placeholderText="Circular Date"
                                                                dayClassName={() => "example-datepicker-day-class"}
                                                                popperClassName="example-datepicker-class" />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{circularDateErr}</span>}
                                                        </div>
                                                        <div className="col-xl-8">
                                                            <label htmlFor="validationCustom03">Circular Name<span style={{ color: 'red' }}>*</span></label>
                                                            <input type="text" className="form-control"
                                                                value={circularTitle}
                                                                maxLength={150}
                                                                onInput={toInputUppercase}
                                                                onChange={(e) => this.setState({ circularTitle: e.target.value, circularTitleErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{circularTitleErr}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="mt-4 mb-3">
                                                        {circularFileName == '' ?
                                                            <div class="form-group">
                                                                <div class="form-group mt-1" >
                                                                    <input type="file" name="files[]" multiple class="custom-file-input form-control"
                                                                        id="customFile"
                                                                        accept=".pdf"
                                                                        onChange={e => this.onFilePick(e, e.target.files)}
                                                                    />
                                                                    <label class="custom-file-label" for="customFile"
                                                                    >Upload Circular</label>
                                                                </div>
                                                            </div> :
                                                            <div className='membership_file ' style={{ width: '100% !important' }}>
                                                                <span className='overflow-membership' style={{ width: '100% !important' }}>{circularFileName}</span>
                                                                <span
                                                                    className='membership_file_cross text-danger'
                                                                    onClick={(e) => this.removeFile(e)}
                                                                >X</span>
                                                            </div>
                                                        }
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{circularFileErr}</span>}
                                                    </div>
                                                    
                                                    <button type="button" className="btn btn-outline-primary "
                                                        onClick={(e) => this.insertCircular()}
                                                    >
                                                        Submit Circular
                                                    </button>
                                                    <button type="button" className="btn btn-outline-primary  ml-2" 
                                                        onClick={(e) => this.assignCircular()}
                                                    >
                                                        Assign Circular
                                                    </button>
                                                </div>


                                                <div className="col-md-6">
                                                   

                                                    <label htmlFor="validationCustom03">Description<span style={{ color: 'red' }}>*</span></label>
                                                        <textarea type="text" className="form-control text-hei"
                                                            rows={3}
                                                            cols={5}
                                                            maxLength={1000}
                                                            value={Description}
                                                            onChange={(e) => this.setState({ Description: e.target.value, DescriptionErr: "" })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{DescriptionErr}</span>}
                                                </div>
                                                <style
                                                    type="text/css"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            "\n                                    .del-btn-cir{\n width: 100px; height: 30px; line-height: 15px;\n                                    }\n                                                                                                     "
                                                    }}
                                                />
                                                

                                            </div>

                                            <div className="row m-0">
                                            <div className="col-xl-12 p-0 mt-4">
                                                    <div className="border rounded-2 p-4 pt-1">
                                                        <div className="add-circular">
                                                            {
                                                                circularList.length > 0 && circularList.map((data, index) => (
                                                                    <p key={Math.random()} className="mt-2">
                                                                        <div className="chiller_cb" >
                                                                            <input type="checkbox"
                                                                                checked={data.isSelect}
                                                                                onChange={(e) => this.checkedCirculars(e, data.circular_id)}
                                                                                id={`circular-${index}`} />

                                                                            <div className="overflow-membership" style={{ paddingTop: '5px', width: '100%' }}>
                                                                                <label
                                                                                    className="lebel-dis"
                                                                                    htmlFor={`circular-${index}`}
                                                                                    style={{ color: 'black' }}
                                                                                    title={data.title}
                                                                                >
                                                                                    {data.title} 
                                                                                </label>
                                                                            </div>
                                                                            <span></span>
                                                                            <a
                                                                                type="button"
                                                                                className="border text-danger ml-2 rounded-2 p-1 px-2 w-auto cir-del"
                                                                                onClick={(e) => this.delCircular(data.circular_id)}
                                                                            >
                                                                                <i class="fa fa-trash-o" aria-hidden="true"></i>
                                                                            </a>
                                                                        </div>
                                                                    </p>
                                                                ))
                                                            }

                                                        </div>
                                                    </div>
                                                    </div>
                                            </div>

                                            <hr className="mt-4" />
                                            <div className="row">

                                                <div className="col-md-3">
                                                    <label htmlFor="validationCustom03">Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search Name"
                                                        value={companyName}
                                                        onChange={(e) => this.setState({ companyName: e.target.value })}
                                                    />
                                                </div>
                                                {/* <div className="col-md-3">
                                                        <label htmlFor="validationCustom03">Application No</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search Application No"
                                                            value={ApplicationNo}
                                                            onChange={(e) => this.setState({ ApplicationNo: e.target.value })}
                                                        />
                                                    </div> */}
                                                <div className="col-md-3">
                                                    <label htmlFor="validationCustom03">User Type</label>
                                                    <select className="form-select"
                                                        value={userTypeId}
                                                        onChange={(e) => this.setState({ userTypeId: e.target.value })}
                                                    >
                                                        <option value={'All'}>All</option>
                                                        <option value={'Jury'}>Jury</option>
                                                        <option value={'Applicant'}>Applicant</option>
                                                    </select>
                                                </div>
                                                {/* <div className="col-md-3">
                                                        <label htmlFor="validationCustom03">PaymentType Type</label>
                                                        <select className="form-control"
                                                            value={paymentTypeId}
                                                            onChange={(e) => this.setState({ paymentTypeId: e.target.value })}
                                                        >
                                                            <option value={null}>Select</option>
                                                            <option value={'Paid'}>Paid</option>
                                                            <option value={'Unpaid'}>Unpaid</option>
                                                        </select>
                                                    </div> */}
                                                <div className="col-md-2">
                                                    <label>&nbsp;</label>
                                                    <button class="btn btn-outline-primary  mr-3"
                                                        onClick={(e) => this.onSearchClick()}
                                                    >Search</button><button class="btn btn-outline-danger"
                                                    onClick={(e) => this.handleFilterClear()}
                                                >Clear</button>
                                                </div>
                                                    {/* <div className="col-md-2 mt-1 p-0" >
                                                <label>&nbsp;</label>
                                                    <div className="chiller_cb" >
                                                        <label
                                                            className="lebel-dis lebel-dis2"
                                                            htmlFor={`circular`}

                                                        >
                                                            <input type="checkbox"
                                                            checked={this.state.isSendMail}
                                                            onChange={(e) => this.setState({ isSendMail: !this.state.isSendMail })}
                                                            id={`circular`} />
                                                            Send Mail
                                                        </label>
                                                        <span></span>
                                                    </div>
                                                </div> */}

                                            </div>
                                            <div className="row mt-2">
                                                <div class="custom_table d-flex">
                                                    <div class="hack1">
                                                        <div class="hack2">
                                                            <table class="table table-bordered" id="dashboard-table">
                                                                <thead>
                                                                    <tr style={{ background: "#E6E6E6" }}>
                                                                        <th style={{ width: '10px' }}>
                                                                            <div class="bg" style={{ justifyContent: 'center', alignItems: 'center' }}>
                                                                                <div class="chiller_cb" >
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        id={`SelectAll-circular`}
                                                                                        checked={checkedAll}
                                                                                        onChange={(e) => this.selectAllCompany(e)}
                                                                                    />
                                                                                    <label
                                                                                        for={`SelectAll-circular`}
                                                                                        style={{ color: "#979797;" }}>&nbsp;</label>
                                                                                    <span></span>
                                                                                </div>
                                                                            </div>
                                                                        </th>
                                                                        {/* <th>Application No</th> */}
                                                                        <th>Name</th>
                                                                        <th>Type</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody id="myTable">
                                                                    {currentRecords.length > 0 ?
                                                                        currentRecords.map((data, i) => (
                                                                            <tr >
                                                                                <td >
                                                                                    <div class="bg" style={{ justifyContent: 'center', alignItems: 'center' }}>
                                                                                        <div class="chiller_cb" >
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                id={`circular${i}`}
                                                                                                value={data.isSelected}
                                                                                                checked={data.Is_Select}
                                                                                                onChange={(e) => this.handleCheckedCompany(e, data.user_id)}
                                                                                            />
                                                                                            <label
                                                                                                for={`circular${i}`}
                                                                                                style={{ color: "#979797;" }}>&nbsp;</label>
                                                                                            <span></span>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                {/* <td >{data.application_no != '' ? data.application_no : '-'}</td> */}
                                                                                <td >{data.name != null ? data.name : '-'}</td>
                                                                                <td >{data.type}</td>
                                                                            </tr>
                                                                        )) :
                                                                        <tr>
                                                                            <td colSpan={7} className="text-center">Record not found</td>
                                                                        </tr>

                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="mt-2 float-left" style={{position:'relative'}}>
                                                    {
                                                        companyList.length > 0 ?
                                                            <Pagination
                                                                nPages={nPages}
                                                                currentPage={currentPage}
                                                                setCurrentPage={this.updateItem}
                                                            /> : <></>
                                                    }
                                                    <div className="tab-rec " style={{ float: "right" }}>
                                                        <p>{`${currentPage} of ${nPages} pages`}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </main>
                    </>
                )
                }
                <Footer />
                <ToastContainer />
            </>
        );
    }
}

export default withRouter(
    connect(null, {
        fill_action,
        getCircularCompany_action,
        getCircularList_action,
        insertCicular_action,
        delCircular_action,
        forgetPassword_action,
        assignCircular_action
    })(AdminCircular)
);
